import React from 'react';

function Instruction() {
  return (
    <div className="mb-10">
      <p className="govuk-body">
        Please share this Advance Care Care Plan whenever it is suitable to do
        so. When updates and changes are saved, the latest version will be
        available for sharing.
      </p>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">
            Learn more about sharing Advance Care Plans
          </span>
        </summary>
        <div className="govuk-details__text">
          <p className="govuk-body">
            When an Advance Care Plan has been completed and whenever it is
            updated please carry out the following tasks:
          </p>
          <ol className="govuk-list govuk-list--number">
            <li>
              Print at least one copy for the person you are supporting to keep
              in their possession.
            </li>
            <li>
              Share the document with the person’s next of kin. We recommend
              emailing them a copy (when it is possible to do so) and providing
              them with a printed version.
            </li>
            <li>
              If the person you are supporting is a resident in a care home or
              hospice, print at least one copy and make it available for you and
              colleagues to refer to at any given moment in time in the future.
            </li>
            <li>
              If there are other ways in which you and the organisation you work
              for shares Advance Care Plans both internally and externally,
              please expand and adapt this guidance accordingly.
            </li>
          </ol>
        </div>
      </details>
    </div>
  );
}

export default Instruction;
